import { GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "./config";  // Asegúrate de que la ruta sea correcta

// http://127.0.0.1:500x0 --> https://denegocios.herokxuapp.com
const getState = ({ getStore, getActions, setStore }) => {
	function sortByMonth(arr) {
		//Esta funcion permite ordenar los meses de los pagos. Ver cada getPago2019
		const meses = [
			"Diciembre",
			"Noviembre",
			"Octubre",
			"Septiembre",
			"Agosto",
			"Julio",
			"Junio",
			"Mayo",
			"Abril",
			"Marzo",
			"Febrero",
			"Enero",
		];
		arr.sort(function (a, b) {
			return meses.indexOf(a.mes) - meses.indexOf(b.mes);
		});
	}

	const fechaSessionStorage = () => {
		const fecha = new Date();
		const opciones = {
			year: "numeric",
			month: "long",
			day: "2-digit",
		};
		return `${fecha.toLocaleDateString(
			"es-ES",
			opciones
		)} a las ${fecha.toLocaleTimeString()}`;
	};

	return {
		store: {
			witch: true, //Setea existencia de barra lateral izquierda
			usuarios: null,
			usuario: null,
			response: null,
			clientesDt: [{}], //null, //Lista de Clientes de Dt
			paginasClientesDt: null, //Total de Paginas para los Clientes Dt
			paginaActualClientesDt: null, //Total Clientes en Dt
			infoClienteDt: null, //ClienteDt Seleccionado
			nota: null, //Notas especificas al id del ClienteDt seleccionado
			pago2019: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2020: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2021: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2022: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2023: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2024: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2025: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2026: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2027: null, //Pagos especificos al id del ClienteDt seleccionado
			clientesDtProvidencia: [{}], //null, //Lista de Clientes de Dt
			paginasClientesDtProvidencia: null, //Total de Paginas para los Clientes Dt
			paginaActualClientesDtProvidencia: null, //Total Clientes en Dt
			infoClienteDtProvidencia: null, //ClienteDt Seleccionado
			notaProvidencia: null, //Notas especificas al id del ClienteDt seleccionado
			pago2025Providencia: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2026Providencia: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2027Providencia: null, //Pagos especificos al id del ClienteDt seleccionado
			clientesDtBodega: [{}], //null, //Lista de Clientes de Dt
			paginasClientesDtBodega: null, //Total de Paginas para los Clientes Dt
			paginaActualClientesDtBodega: null, //Total Clientes en Dt
			infoClienteDtBodega: null, //ClienteDt Seleccionado
			notaBodega: null, //Notas especificas al id del ClienteDt seleccionado
			pago2025Bodega: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2026Bodega: null, //Pagos especificos al id del ClienteDt seleccionado
			pago2027Bodega: null, //Pagos especificos al id del ClienteDt seleccionado
			usuarioActual:
				JSON.parse(localStorage.getItem("usuarioActual")) === null
					? null
					: JSON.parse(localStorage.getItem("usuarioActual")), //Usuario Actual que está Conectado
			token:
				localStorage.getItem("token") === null
					? null
					: localStorage.getItem("token"), //Token del Usuario Actual Conectado
			paginaActual:
				sessionStorage.getItem("paginaActual") === null
					? null
					: sessionStorage.getItem("paginaActual"),
			spinner: false,
			clientesContabilidad: null,
			paginasClientesContabilidad: null,
			paginaActualClientesContabilidad: null,
			infoClienteContabilidad: null,
			notaContabilidad: null,
			pagoContabilidad: null,
			ventasUsuario: null,
			ventasUsuarioVendedores: null,
			ventasUsuarioPorId: null,
			ventasUsuarioEstadisticas: null,
			patentes: null,
			patente: null,
			patentesEncontradas: [], // Nueva propiedad para almacenar resultados de búsqueda
			patentesFiltroMes: null,
		},

		actions: {
			//setWitch cambia la barra lateral izquierda.
			setWitch: () => {
				const store = getStore();
				
				store.witch ? setStore({ witch: false }) : setStore({ witch: true });
			},

			setPaginaActual: (paginaActual) => {
				sessionStorage.setItem("paginaActual", paginaActual);
				setStore({ paginaActual: paginaActual });
			},

			setVentaUsuariostoNull: () => {
				setStore({
					ventasUsuario: null,
				});
			},

			setSpinner: () => {
				const store = getStore();
				store.spinner
					? setStore({ spinner: false })
					: setStore({ spinner: true });
			},

			/* USUARIOS Y LOGIN */
			loginUsuario: async (correo, clave) => {
				const actions = getActions();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/login", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ correo: correo, clave: clave }),
				})
					.then((res) => {
						if (res.status === 200) return res.json();
						else if (res.status === 401) {
							alert("Usuario o clave Incorrecto");
							setStore({ spinner: false });
						} else if (res.status === 500) {
							//BD debería mandar un mensaje que indique que usuario no está, más que 500 response.
							alert("Hay un problema, revisa tus credenciales");
							setStore({ spinner: false });
						}
					})
					.then((data) => {
						localStorage.setItem("usuarioActual", JSON.stringify(data[0]));
						localStorage.setItem("token", data[1]);
						setStore({ usuarioActual: data[0], token: data[1] });
						setStore({ spinner: false });
					})
					.catch((error) => {
						console.error("Hay un problemilla", error);
					});
			},

			loginFirebase: async () => {
				try {
					// El spinner ya está activo desde HandlerLoginGoogle
					const provider = new GoogleAuthProvider();
					provider.setCustomParameters({
						'hd': 'denegocios.cl'
					});

					const result = await signInWithPopup(auth, provider);
					const user = result.user;

					if (!user.email.endsWith('@denegocios.cl')) {
						throw new Error("Solo se permiten correos del dominio denegocios.cl");
					}

					const idToken = await user.getIdToken();

					const response = await fetch("https://denegocios.herokuapp.com/login-firebase", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ 
							firebaseToken: idToken,
							email: user.email
						}),
					});

					if (!response.ok) {
						const errorData = await response.json();
						throw new Error(errorData.error || "Error en la autenticación con el servidor");
					}

					const data = await response.json();

					// Calcular tiempo de expiración (24 horas desde ahora)
					const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
					
					// Guardar datos en localStorage
					localStorage.setItem("usuarioActual", JSON.stringify(data.usuario));
					localStorage.setItem("token", data.token);
					localStorage.setItem("sessionExpiration", expirationTime.toString());
					
					// Actualizar store y apagar spinner
					setStore({ 
						usuarioActual: data.usuario, 
						token: data.token,
						spinner: false
					});

					return { success: true };

				} catch (error) {
					console.error("Error en loginFirebase:", error);
					setStore({ spinner: false });
					return { 
						success: false, 
						error: error.message === "Solo se permiten correos del dominio denegocios.cl" 
							? error.message 
							: "Error en la autenticación. Por favor, intenta nuevamente."
					};
				}
			},
			
			loginFirebaseEmail: async (email, password) => {
				try {
					// 1. Autenticación con Firebase usando email/password
					const userCredential = await signInWithEmailAndPassword(
						auth,
						email,
						password
					);
					
					// 2. Obtener el token
					const idToken = await userCredential.user.getIdToken();

					// 3. Validar que sea un correo de denegocios.cl
					if (!userCredential.user.email.endsWith('@denegocios.cl')) {
						throw new Error("Solo se permiten correos del dominio denegocios.cl");
					}

					// 4. Autenticar con nuestro backend
					const response = await fetch("https://denegocios.herokuapp.com/login-firebase", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ 
							firebaseToken: idToken,
							email: userCredential.user.email
						}),
					});

					if (!response.ok) {
						const errorData = await response.json();
						throw new Error(errorData.error || "Error en la autenticación con el servidor");
					}

					const data = await response.json();

					// 5. Guardar datos en localStorage y store
					const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
					localStorage.setItem("usuarioActual", JSON.stringify(data.usuario));
					localStorage.setItem("token", data.token);
					localStorage.setItem("sessionExpiration", expirationTime.toString());
					
					setStore({ 
						usuarioActual: data.usuario, 
						token: data.token,
						spinner: false
					});

					return { success: true };

				} catch (error) {
					console.error("Error en login con email/password:", error);
					setStore({ spinner: false });
					return { 
						success: false, 
						error: error.message || "Error de autenticación. Verifica tus credenciales." 
					};
				}
			},

			getUsuario: async (usuarioid) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/usuario/" + usuarioid, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					if (!response.ok) {
						const data = await response.json();
						throw new Error(data.error || "Error al obtener usuario");
					}

					const data = await response.json();
					setStore({
						usuario: data,
					});
				} catch (error) {
					console.error("Error en getUsuario:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			getUsuarios: async () => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/usuario", {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					if (!response.ok) {
						const data = await response.json();
						throw new Error(data.error || "Error al obtener usuarios");
					}

					const data = await response.json();
					setStore({
						usuarios: data,
					});
				} catch (error) {
					console.error("Error en getUsuarios:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			crearUsuario: async (nombre, apellido, correo, clave, tipo) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/usuario", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							nombre,
							apellido,
							correo,
							clave,
							tipo,
							fechaCreacion: fechaSessionStorage(),
							fechaModificacion: fechaSessionStorage()
						}),
					});

					if (!response.ok) {
						const data = await response.json();
						throw new Error(data.error || "Error al crear usuario");
					}

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en crearUsuario:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarUsuario: async (id, nombre, apellido, correo, clave, tipo) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch(`https://denegocios.herokuapp.com/usuario/${id}`, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							nombre: nombre === "" ? null : nombre,
							apellido: apellido === "" ? null : apellido,
							correo: correo === "" ? null : correo,
							clave: clave === "" ? null : clave,
							tipo: tipo === "" ? null : tipo,
							fechaModificacion: fechaSessionStorage()
						}),
					});

					if (!response.ok) {
						const data = await response.json();
						throw new Error(data.error || "Error al editar usuario");
					}

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarUsuario:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			borrarUsuario: async (id) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch(`https://denegocios.herokuapp.com/usuario/${id}`, {
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					if (!response.ok) {
						const data = await response.json();
						throw new Error(data.error || "Error al borrar usuario");
					}

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en borrarUsuario:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			logoutFirebase: async () => {
				try {
					// Cerrar sesión en Firebase
					await signOut(auth);
					
					// Limpiar localStorage
					localStorage.removeItem("usuarioActual");
					localStorage.removeItem("token");
					localStorage.removeItem("sessionExpiration");
					sessionStorage.removeItem("paginaActual");
					
					// Limpiar store
					setStore({
						usuarioActual: null,
						token: null
					});
					
					return { success: true };
				} catch (error) {
					console.error("Error en logoutFirebase:", error);
					return { 
						success: false, 
						error: error.message 
					};
				}
			},

			/* CLIENTES DIRECCION TRIBUTARIA */

			/* Si */
			/* Busqueda con Usuario Normal y Listas de Cobranzas */
			getBusquedaDt: async (busqueda, tipoDato = "Nada") => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/busquedaDt", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							busqueda: busqueda,
						}),
					});

					if (!response.ok) {
						if (response.status === 404) {
							// Sin resultados encontrados - establecer arrays vacíos
							setStore({
								clientesDt: [],
								paginasClientesDt: 0,
								paginaActualClientesDt: 1,
							});
							return;
						} else {
							// Otros errores del servidor
							const errorData = await response.json().catch(() => ({ error: "Error del servidor" }));
							throw new Error(errorData.error || `Error del servidor: ${response.status}`);
						}
					}

					const data = await response.json();
					setStore({
						clientesDt: data[0] || [],
						paginasClientesDt: data[1] || 0,
						paginaActualClientesDt: data[2] || 1,
					});

					if (tipoDato === "Con Deuda" || tipoDato === "Sin Deuda" || tipoDato === "Todo" ||
						tipoDato === "Vigente" || tipoDato === "No Vigente" || tipoDato === "Con Patente" ||
						tipoDato === "Sin Patente" || tipoDato === "Con DICOM" || tipoDato === "Sin DICOM") {
						sessionStorage.setItem("listadoClientesDt", JSON.stringify(data[0] || []));
						sessionStorage.setItem("dateClientesDt", fechaSessionStorage());
						sessionStorage.setItem("dateClientesDtLlamada", JSON.stringify(new Date().toLocaleDateString()));
					}
				} catch (error) {
					console.error("Error en getBusquedaDt:", error);
					setStore({
						clientesDt: [],
						paginasClientesDt: 0,
						paginaActualClientesDt: 1,
						error: error.message
					});
				} finally {
					setTimeout(() => {
						setStore({ spinner: false });
					}, 1000);
				}
			},
			/* Si */
			getClienteDt: async (clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDt/" + clienteDtid, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					const data = await response.json();
					setStore({
						infoClienteDt: data,
					});
				} catch (error) {
					console.error("Error en getClienteDt:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},
			/* Si */
			crearClienteDt: async (
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				representante,
				rutRepresentante,
				fechaContratacion,
				erpyme,
				p,
				sacar,
				dicom,
				contratoActualizado,
				patente,
				libre,
				mesesPagados,
				mesesPagados2023,
				tipoPago
			) => {
				const store = getStore();
				setStore({ spinner: true, response: null });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDt", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon, rut, vigente, correo, correoSecundario, correoTerciario,
							fono, whatsapp, representante, rutRepresentante, fechaContratacion,
							erpyme, p, sacar, dicom, contratoActualizado, patente, libre,
							mesesPagados, mesesPagados2023, tipoPago,
							fechaCreacion: fechaSessionStorage(),
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en crearClienteDt:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},
			/* Si */
			editarClienteDt: async (
				id,
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				representante,
				rutRepresentante,
				fechaContratacion,
				erpyme,
				p,
				sacar,
				dicom,
				contratoActualizado,
				patente,
				libre,
				mesesPagados,
				mesesPagados2023,
				tipoPago
			) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDt/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: razon === "" ? null : razon,
							rut: rut === "" ? null : rut,
							vigente: vigente === "" ? null : vigente,
							correo: correo === "" ? null : correo,
							correoSecundario: correoSecundario === "" ? null : correoSecundario,
							correoTerciario: correoTerciario === "" ? null : correoTerciario,
							fono: fono === "" ? null : fono,
							whatsapp: whatsapp === "" ? null : whatsapp,
							representante: representante === "" ? null : representante,
							rutRepresentante: rutRepresentante === "" ? null : rutRepresentante,
							fechaContratacion: fechaContratacion === "" ? null : fechaContratacion,
							erpyme: erpyme === "" ? null : erpyme,
							p: p === "" ? null : p,
							sacar: sacar === "" ? null : sacar,
							dicom: dicom === "" ? null : dicom,
							contratoActualizado: contratoActualizado === "" ? null : contratoActualizado,
							patente: patente === "" ? null : patente,
							libre: libre === "" ? null : libre,
							mesesPagados: mesesPagados === "" ? null : mesesPagados,
							mesesPagados2023: mesesPagados2023 === "" ? null : mesesPagados2023,
							tipoPago: tipoPago === "" ? null : tipoPago,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarClienteDt:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},
			/* Si */
			editarMesesPagados2023ClienteDt: async (id, mesesPagados2023) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDt/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: null,
							rut: null,
							vigente: null,
							correo: null,
							correoSecundario: null,
							correoTerciario: null,
							fono: null,
							whatsapp: null,
							representante: null,
							rutRepresentante: null,
							fechaContratacion: null,
							erpyme: null,
							p: null,
							sacar: null,
							dicom: null,
							contratoActualizado: null,
							patente: null,
							libre: null,
							mesesPagados: null,
							mesesPagados2023: mesesPagados2023,
							tipoPago: null,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarMesesPagados2023ClienteDt:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},
			/* Si */
			editarMesesPagadosClienteDt: async (id, mesesPagados) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDt/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: null,
							rut: null,
							vigente: null,
							correo: null,
							correoSecundario: null,
							correoTerciario: null,
							fono: null,
							whatsapp: null,
							representante: null,
							rutRepresentante: null,
							fechaContratacion: null,
							erpyme: null,
							p: null,
							sacar: null,
							dicom: null,
							contratoActualizado: null,
							patente: null,
							libre: null,
							mesesPagados: mesesPagados,
							mesesPagados2023: null,
							tipoPago: null,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarMesesPagadosClienteDt:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			// /* Notas Direccion Tributaria*/
			getNota: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/nota/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							nota: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			crearNota: async (comentario, fechaComentario, clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/nota", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						comentario: comentario,
						fechaComentario: fechaComentario,
						clienteDtid: clienteDtid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			//  /* Pagos Direccion Tributaria */

			getPago2019: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2019/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2019: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2020: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2020/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2020: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2021: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2021/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2021: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2022: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2022/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2022: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2023: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2023/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2023: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2024: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2024/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2024: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2025: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2025/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2025: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2026: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2026/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2026: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			getPago2027: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2027/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2027: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDT " + error.message,
						});
					});
			},

			crearPago: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				mesesPagados,
				mesesPagados2023,
				facturaNumero,
				comentario,
				fechaIngresoPago,
				clienteDtid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/dt" + year, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						mes: mes,
						numeroTransferencia: numeroTransferencia,
						montoPagado: montoPagado,
						montoCobrado: montoCobrado,
						mesesPagados: mesesPagados,
						mesesPagados2023: mesesPagados2023,
						facturaNumero: facturaNumero,
						comentario: comentario,
						fechaIngresoPago: fechaIngresoPago,
						clienteDtid: clienteDtid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			editarPago: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				mesesPagados,
				mesesPagados2023,
				facturaNumero,
				comentario,
				clienteDtid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/dt" + year + "/" + clienteDtid,
					{
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
						body: JSON.stringify({
							mes: mes === "" ? null : mes,
							numeroTransferencia:
								numeroTransferencia === "" ? null : numeroTransferencia,
							montoPagado: montoPagado === "" ? null : montoPagado,
							montoCobrado: montoCobrado === "" ? null : montoCobrado,
							mesesPagados: mesesPagados === "" ? null : mesesPagados,
							mesesPagados2023:
								mesesPagados2023 === "" ? null : mesesPagados2023,
							facturaNumero: facturaNumero === "" ? null : facturaNumero,
							comentario: comentario === "" ? null : comentario,
							fechaModificacion: fechaSessionStorage(),
						}),
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},
			/* Si */
			borrarPago: async (year, clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/dt" + year + "/" + clienteDtid,
					{
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			/* CLIENTES DIRECCION TRIBUTARIA PROVIDENCIA */

			getBusquedaDtProvidencia: async (busqueda, tipoDato = "Nada") => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/busquedaDtProvidencia", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							busqueda: busqueda,
						}),
					});

					if (!response.ok) {
						if (response.status === 404) {
							// Sin resultados encontrados - establecer arrays vacíos
							setStore({
								clientesDtProvidencia: [],
								paginasClientesDtProvidencia: 0,
								paginaActualClientesDtProvidencia: 1,
							});
							return;
						} else {
							// Otros errores del servidor
							const errorData = await response.json().catch(() => ({ error: "Error del servidor" }));
							throw new Error(errorData.error || `Error del servidor: ${response.status}`);
						}
					}

					const data = await response.json();
					setStore({
						clientesDtProvidencia: data[0] || [],
						paginasClientesDtProvidencia: data[1] || 0,
						paginaActualClientesDtProvidencia: data[2] || 1,
					});

					if (tipoDato === "Con Deuda" || tipoDato === "Sin Deuda" || tipoDato === "Todo" ||
						tipoDato === "Vigente" || tipoDato === "No Vigente" || tipoDato === "Con Patente" ||
						tipoDato === "Sin Patente" || tipoDato === "Con DICOM" || tipoDato === "Sin DICOM") {
						sessionStorage.setItem("listadoClientesDtProvidencia", JSON.stringify(data[0] || []));
						sessionStorage.setItem("dateClientesDtProvidencia", fechaSessionStorage());
						sessionStorage.setItem("dateClientesDtProvidenciaLlamada", JSON.stringify(new Date().toLocaleDateString()));
					}
				} catch (error) {
					console.error("Error en getBusquedaDtProvidencia:", error);
					setStore({
						clientesDtProvidencia: [],
						paginasClientesDtProvidencia: 0,
						paginaActualClientesDtProvidencia: 1,
						error: error.message
					});
				} finally {
					setTimeout(() => {
						setStore({ spinner: false });
					}, 1000);
				}
			},

			getClienteDtProvidencia: async (clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDtProvidencia/" + clienteDtid, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					const data = await response.json();
					setStore({
						infoClienteDtProvidencia: data,
					});
				} catch (error) {
					console.error("Error en getClienteDtProvidencia:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			crearClienteDtProvidencia: async (
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				representante,
				rutRepresentante,
				fechaContratacion,
				erpyme,
				p,
				sacar,
				dicom,
				contratoActualizado,
				patente,
				libre,
				mesesPagados,
				mesesPagados2023,
				tipoPago
			) => {
				const store = getStore();
				setStore({ spinner: true, response: null });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDtProvidencia", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon, rut, vigente, correo, correoSecundario, correoTerciario,
							fono, whatsapp, representante, rutRepresentante, fechaContratacion,
							erpyme, p, sacar, dicom, contratoActualizado, patente, libre,
							mesesPagados, mesesPagados2023, tipoPago,
							fechaCreacion: fechaSessionStorage(),
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en crearClienteDtProvidencia:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarClienteDtProvidencia: async (
				id,
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				representante,
				rutRepresentante,
				fechaContratacion,
				erpyme,
				p,
				sacar,
				dicom,
				contratoActualizado,
				patente,
				libre,
				mesesPagados,
				mesesPagados2023,
				tipoPago
			) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDtProvidencia/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: razon === "" ? null : razon,
							rut: rut === "" ? null : rut,
							vigente: vigente === "" ? null : vigente,
							correo: correo === "" ? null : correo,
							correoSecundario: correoSecundario === "" ? null : correoSecundario,
							correoTerciario: correoTerciario === "" ? null : correoTerciario,
							fono: fono === "" ? null : fono,
							whatsapp: whatsapp === "" ? null : whatsapp,
							representante: representante === "" ? null : representante,
							rutRepresentante: rutRepresentante === "" ? null : rutRepresentante,
							fechaContratacion: fechaContratacion === "" ? null : fechaContratacion,
							erpyme: erpyme === "" ? null : erpyme,
							p: p === "" ? null : p,
							sacar: sacar === "" ? null : sacar,
							dicom: dicom === "" ? null : dicom,
							contratoActualizado: contratoActualizado === "" ? null : contratoActualizado,
							patente: patente === "" ? null : patente,
							libre: libre === "" ? null : libre,
							mesesPagados: mesesPagados === "" ? null : mesesPagados,
							mesesPagados2023: mesesPagados2023 === "" ? null : mesesPagados2023,
							tipoPago: tipoPago === "" ? null : tipoPago,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarClienteDtProvidencia:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarMesesPagados2023ClienteDtProvidencia: async (id, mesesPagados2023) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDtProvidencia/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: null,
							rut: null,
							vigente: null,
							correo: null,
							correoSecundario: null,
							correoTerciario: null,
							fono: null,
							whatsapp: null,
							representante: null,
							rutRepresentante: null,
							fechaContratacion: null,
							erpyme: null,
							p: null,
							sacar: null,
							dicom: null,
							contratoActualizado: null,
							patente: null,
							libre: null,
							mesesPagados: null,
							mesesPagados2023: mesesPagados2023,
							tipoPago: null,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarMesesPagados2023ClienteDtProvidencia:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarMesesPagadosClienteDtProvidencia: async (id, mesesPagados) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteDtProvidencia/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: null,
							rut: null,
							vigente: null,
							correo: null,
							correoSecundario: null,
							correoTerciario: null,
							fono: null,
							whatsapp: null,
							representante: null,
							rutRepresentante: null,
							fechaContratacion: null,
							erpyme: null,
							p: null,
							sacar: null,
							dicom: null,
							contratoActualizado: null,
							patente: null,
							libre: null,
							mesesPagados: mesesPagados,
							mesesPagados2023: null,
							tipoPago: null,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarMesesPagadosClienteDtProvidencia:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			// /* Notas Direccion Tributaria Providencia*/
			getNotaProvidencia: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/notaProvidencia/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							notaProvidencia: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDTProvidencia " + error.message,
						});
					});
			},

			crearNotaProvidencia: async (comentario, fechaComentario, clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/notaProvidencia", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						comentario: comentario,
						fechaComentario: fechaComentario,
						clienteDtid: clienteDtid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			//  /* Pagos Direccion Tributaria Providencia */

			getPago2025Providencia: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2025Providencia/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2025Providencia: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDTProvidencia " + error.message,
						});
					});
			},

			getPago2026Providencia: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2026Providencia/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2026Providencia: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDTProvidencia " + error.message,
						});
					});
			},

			getPago2027Providencia: async (clienteDtid) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/dt2027Providencia/" + clienteDtid, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						sortByMonth(data);
						setStore({
							pago2027Providencia: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesDTProvidencia " + error.message,
						});
					});
			},

			crearPagoProvidencia: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				mesesPagados,
				mesesPagados2023,
				facturaNumero,
				comentario,
				fechaIngresoPago,
				clienteDtid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/dt" + year + "Providencia", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						mes: mes,
						numeroTransferencia: numeroTransferencia,
						montoPagado: montoPagado,
						montoCobrado: montoCobrado,
						mesesPagados: mesesPagados,
						mesesPagados2023: mesesPagados2023,
						facturaNumero: facturaNumero,
						comentario: comentario,
						fechaIngresoPago: fechaIngresoPago,
						clienteDtid: clienteDtid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			editarPagoProvidencia: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				mesesPagados,
				mesesPagados2023,
				facturaNumero,
				comentario,
				clienteDtid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/dt" + year + "Providencia/" + clienteDtid,
					{
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
						body: JSON.stringify({
							mes: mes === "" ? null : mes,
							numeroTransferencia:
								numeroTransferencia === "" ? null : numeroTransferencia,
							montoPagado: montoPagado === "" ? null : montoPagado,
							montoCobrado: montoCobrado === "" ? null : montoCobrado,
							mesesPagados: mesesPagados === "" ? null : mesesPagados,
							mesesPagados2023:
								mesesPagados2023 === "" ? null : mesesPagados2023,
							facturaNumero: facturaNumero === "" ? null : facturaNumero,
							comentario: comentario === "" ? null : comentario,
							fechaModificacion: fechaSessionStorage(),
						}),
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			borrarPagoProvidencia: async (year, clienteDtid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/dt" + year + "Providencia/" + clienteDtid,
					{
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			/* CLIENTES DE CONTABILIDAD */

			getClientesContabilidad: async (page_num) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/xContabilidad/" + page_num, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					const data = await response.json();
					setStore({
						clientesContabilidad: data[0],
						paginasClientesContabilidad: data[1],
						paginaActualClientesContabilidad: data[2],
					});						
				} catch (error) {
					console.error("Error en getClientesContabilidad:", error);
					setStore({
						error: "clientesContabilidad " + error.message
					});
				} finally {
					setTimeout(() => {
						setStore({ spinner: false });
					}, 1000);
				}
			},

			/* Este se supone que es para barra de busqueda de clientes contabilidad */
			getBusquedaContabilidad: async (busqueda, tipoDato = "Nada") => {
				const store = getStore();
				setStore({ spinner: true });
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/busquedaContabilidad", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							busqueda: busqueda,
						}),
					});

					if (!response.ok) {
						if (response.status === 404) {
							// Sin resultados encontrados - establecer arrays vacíos
							setStore({
								clientesContabilidad: [],
								paginasClientesContabilidad: 0,
								paginaActualClientesContabilidad: 1,
							});
							return;
						} else {
							// Otros errores del servidor
							const errorData = await response.json().catch(() => ({ error: "Error del servidor" }));
							throw new Error(errorData.error || `Error del servidor: ${response.status}`);
						}
					}

					const data = await response.json();
					setStore({
						clientesContabilidad: data[0] || [],
						paginasClientesContabilidad: data[1] || 0,
						paginaActualClientesContabilidad: data[2] || 1,
					});

					if (tipoDato === "Todo" || tipoDato === "Vigente" || tipoDato === "No Vigente" ||
						tipoDato === "Con DICOM" || tipoDato === "Con Riesgo") {
						sessionStorage.setItem("listadoClientesConta", JSON.stringify(data[0] || []));
						sessionStorage.setItem("dateClientesConta", fechaSessionStorage());
						sessionStorage.setItem("dateClientesContaLlamada", JSON.stringify(new Date().toLocaleDateString()));
					}
				} catch (error) {
					console.error("Error en getBusquedaContabilidad:", error);
					setStore({
						clientesContabilidad: [],
						paginasClientesContabilidad: 0,
						paginaActualClientesContabilidad: 1,
						error: "clientesContabilidad " + error.message
					});
				} finally {
					setTimeout(() => {
						setStore({ spinner: false });
					}, 1000);
				}
			},

			/* Si se está usando */
			getBusquedaFiltroContabilidad: async (vigente, whatsapp, erpyme, dicom, repetido) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/filtroContabilidad", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							vigente: vigente === "Selecciona..." ? null : vigente,
							whatsapp: whatsapp === "Selecciona..." ? null : whatsapp,
							erpyme: erpyme === "Selecciona..." ? null : erpyme,
							dicom: dicom === "Selecciona..." ? null : dicom,
							repetido: repetido === "Selecciona..." ? null : repetido,
						}),
					});

					const data = await response.json();
					setStore({
						clientesContabilidad: data[0],
						paginasClientesContabilidad: data[1],
						paginaActualClientesContabilidad: data[2],
					});
				} catch (error) {
					console.error("Error en getBusquedaFiltroContabilidad:", error);
					setStore({
						error: "clientesContabilidad " + error.message
					});
				} finally {
					setTimeout(() => {
						setStore({ spinner: false });
					}, 1000);
				}
			},

			getClienteContabilidad: async (clienteContabilidadid) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch(
						"https://denegocios.herokuapp.com/clienteContabilidad/" + clienteContabilidadid,
						{
							method: "GET",
							headers: {
								"Content-Type": "application/json",
								"Authorization": `Bearer ${idToken}`
							},
						}
					);

					const data = await response.json();
					setStore({
						infoClienteContabilidad: data,
					});
				} catch (error) {
					console.error("Error en getClienteContabilidad:", error);
					setStore({
						error: "clientesContabilidad " + error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			crearClienteContabilidad: async (
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				erpyme,
				dicom,
				repetido,
				libre
			) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteContabilidad", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon,
							rut,
							vigente,
							correo,
							correoSecundario,
							correoTerciario,
							fono,
							whatsapp,
							erpyme,
							dicom,
							repetido,
							libre,
							fechaCreacion: fechaSessionStorage(),
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en crearClienteContabilidad:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarClienteContabilidad: async (
				id,
				razon,
				rut,
				vigente,
				correo,
				correoSecundario,
				correoTerciario,
				fono,
				whatsapp,
				erpyme,
				dicom,
				repetido,
				libre
			) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/clienteContabilidad/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							razon: razon === "" ? null : razon,
							rut: rut === "" ? null : rut,
							vigente: vigente === "" ? null : vigente,
							correo: correo === "" ? null : correo,
							correoSecundario: correoSecundario === "" ? null : correoSecundario,
							correoTerciario: correoTerciario === "" ? null : correoTerciario,
							fono: fono === "" ? null : fono,
							whatsapp: whatsapp === "" ? null : whatsapp,
							erpyme: erpyme === "" ? null : erpyme,
							dicom: dicom === "" ? null : dicom,
							repetido: repetido === "" ? null : repetido,
							libre: libre === "" ? null : libre,
							fechaModificacion: fechaSessionStorage(),
						}),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en editarClienteContabilidad:", error);
					setStore({
						error: error.message
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			// /* Notas Contabilidad*/
			getNotaContabilidad: async (clienteContabilidadid) => {
				const store = getStore();
				fetch(
					"https://denegocios.herokuapp.com/notaContabilidad/" +
						clienteContabilidadid,
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							notaContabilidad: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesContabilidad " + error.message,
						});
					});
			},

			crearNotaContabilidad: async (
				comentario,
				fechaComentario,
				clienteContabilidadid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/notaContabilidad", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						comentario: comentario,
						fechaComentario: fechaComentario,
						clienteContabilidadid: clienteContabilidadid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			//  /* Pagos Contabilidad */

			getPagoContabilidad: async (clienteContabilidadid) => {
				////Aquí hay que ordenar adicionalmente por Year
				const store = getStore();			
				fetch(
					"https://denegocios.herokuapp.com/pagosContabilidad/" +
						clienteContabilidadid,
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							pagoContabilidad: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "clientesContabilidad" + error.message,
						});
					});					
			},

			crearPagoContabilidad: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				facturaNumero,
				comentario,
				clienteContabilidadid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/pagosContabilidad", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						year: year,
						mes: mes,
						numeroTransferencia: numeroTransferencia,
						montoPagado: montoPagado,
						montoCobrado: montoCobrado,
						facturaNumero: facturaNumero,
						comentario: comentario,
						clienteContabilidadid: clienteContabilidadid,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			editarPagoContabilidad: async (
				year,
				mes,
				numeroTransferencia,
				montoPagado,
				montoCobrado,
				facturaNumero,
				comentario,
				clienteContabilidadid
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/pagosContabilidad/" +
						clienteContabilidadid,
					{
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
						body: JSON.stringify({
							year: year === "" ? null : year,
							mes: mes === "" ? null : mes,
							numeroTransferencia:
								numeroTransferencia === "" ? null : numeroTransferencia,
							montoPagado: montoPagado === "" ? null : montoPagado,
							montoCobrado: montoCobrado === "" ? null : montoCobrado,
							facturaNumero: facturaNumero === "" ? null : facturaNumero,
							comentario: comentario === "" ? null : comentario,
							fechaModificacion: fechaSessionStorage(),
						}),
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			borrarPagoContabilidad: async (clienteContabilidadid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/pagosContabilidad/" +
						clienteContabilidadid,
					{
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			/* Ventas Usuarios */

			getVentasUsuario: async () => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/ventaUsuarios", {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							ventasUsuario: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "ventasUsuarios" + error.message,
						});
					});
			},

			getVentasUsuarioPorID: async (id) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/ventaUsuarios/" + id, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							ventasUsuarioPorId: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: "ventasUsuarios" + error.message,
						});
					});
			},

			getVentaUsuarioEspecifico: async (usuarioid) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch("https://denegocios.herokuapp.com/ventaUsuarioEspecifico", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						usuarioid: usuarioid,
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							ventasUsuarioVendedores: data,
						});
						sessionStorage.setItem("dateVentasMeses", true);
						{
							data[0] && sessionStorage.setItem("ventasMes0", data[0].ventas);
						}
						{
							data[1] && sessionStorage.setItem("ventasMes1", data[1].ventas);
						}
						{
							data[2] && sessionStorage.setItem("ventasMes2", data[2].ventas);
						}
						{
							data[3] && sessionStorage.setItem("ventasMes3", data[3].ventas);
						}
						{
							data[4] && sessionStorage.setItem("ventasMes4", data[4].ventas);
						}
						{
							data[5] && sessionStorage.setItem("ventasMes5", data[5].ventas);
						}
						{
							data[6] && sessionStorage.setItem("ventasMes6", data[6].ventas);
						}
						{
							data[7] && sessionStorage.setItem("ventasMes7", data[7].ventas);
						}
						{
							data[8] && sessionStorage.setItem("ventasMes8", data[8].ventas);
						}
						{
							data[9] && sessionStorage.setItem("ventasMes9", data[9].ventas);
						}
						{
							data[10] &&
								sessionStorage.setItem("ventasMes10", data[10].ventas);
						}
						{
							data[11] &&
								sessionStorage.setItem("ventasMes11", data[11].ventas);
						}
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: "ventasUsuarios" + error.message,
						});
					});
			},

			getVentasUsuariosModificarIngresoDatos: async (
				yearIngreso,
				mesIngreso
			) => {
				const store = getStore();
				setStore({ spinner: true });
				fetch(
					"https://denegocios.herokuapp.com/getVentasUsuariosModificarIngresoDatos",
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + store.token,
						},
						body: JSON.stringify({
							yearIngreso: yearIngreso === "Selecciona..." ? null : yearIngreso,
							mesIngreso: mesIngreso === "Selecciona..." ? null : mesIngreso,
						}),
					}
				)
					.then((response) => response.json())
					.then((data) => {
						setStore({
							ventasUsuario: data,
						});
						setStore({ spinner: false });
					})
					.catch((error) => {
						setStore({
							error: "ventasUsuarios modificacion datos" + error.message,
						});
					});
			},

			crearVentaEspecifica: async (
				yearIngreso,
				mesIngreso,
				ventas,
				ventasTotales,
				ventasTotalesPasado,
				kpi,
				gastoAds,
				totalPosibles,
				adsPorVendedor,
				posiblesPorVendedor,
				facturasPendientes,
				sueldoBase,
				comisionBase,
				sueldoLiquido,
				id,
				nombre
			) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/ventaUsuarios", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						yearIngreso: yearIngreso,
						mesIngreso: mesIngreso,
						ventas: ventas,
						ventasTotales: ventasTotales,
						ventasTotalesPasado: ventasTotalesPasado,
						kpi: kpi,
						gastoAds: gastoAds,
						totalPosibles: totalPosibles,
						adsPorVendedor: adsPorVendedor,
						posiblesPorVendedor: posiblesPorVendedor,
						facturasPendientes: facturasPendientes,
						sueldoBase: sueldoBase,
						comisionBase: comisionBase,
						sueldoLiquido: sueldoLiquido,
						usuarioid: id,
						nombre: nombre,
						fechaCreacion: fechaSessionStorage(),
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			editarVentaEspecifica: async (
				id,
				mesIngreso = null,
				yearIngreso = null,
				ventas,
				ventasTotales,
				ventasTotalesPasado,
				kpi,
				gastoAds,
				totalPosibles,
				adsPorVendedor,
				posiblesPorVendedor,
				facturasPendientes,
				sueldoBase,
				comisionBase,
				sueldoLiquido
			) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/ventaUsuarios/" + id, {
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						mesIngreso: mesIngreso,
						yearIngreso: yearIngreso,
						ventas: ventas,
						ventasTotales: ventasTotales,
						ventasTotalesPasado: ventasTotalesPasado,
						kpi: kpi,
						gastoAds: gastoAds,
						totalPosibles: totalPosibles,
						adsPorVendedor: adsPorVendedor,
						posiblesPorVendedor: posiblesPorVendedor,
						facturasPendientes: facturasPendientes,
						sueldoBase: sueldoBase,
						comisionBase: comisionBase,
						sueldoLiquido: sueldoLiquido,
						nombre: null,
						usuarioid: null,
						fechaModificacion: fechaSessionStorage(),
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							response: data,
						});
					})
					.catch((error) => {
						setStore({
							error: error.message,
						});
					});
			},

			getEstadisticasVentas: async (yearIngreso, mesIngreso) => {
				const store = getStore();
				fetch("https://denegocios.herokuapp.com/getEstadisticasVentas", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + store.token,
					},
					body: JSON.stringify({
						yearIngreso: yearIngreso,
						mesIngreso: mesIngreso,
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						setStore({
							ventasUsuarioEstadisticas: data,
						});
					})
					.catch((error) => {
						setStore({
							error: "ventasUsuarios modificacion datos" + error.message,
						});
					});
			},

			/* Patentes */

			getPatentes: async (estado = null) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/patentesSegunEstado", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({ estado: estado }),
					});

					const data = await response.json();
					
					// Función auxiliar para procesar strings JSON de manera segura
					const procesarJSON = (str) => {
						if (!str) return [];
						try {
							return JSON.parse(str.replace(/'/g, '"'));
						} catch (e) {
							console.warn("Error procesando JSON:", e);
							return [];
						}
					};

					// Procesar los datos de manera más segura
					const patentesProcessed = data.map(patente => ({
						...patente,
						codigo: procesarJSON(patente.codigo),
						fechaEdicion: procesarJSON(patente.fechaEdicion),
						numeroExpediente: procesarJSON(patente.numeroExpediente)
					}));

					setStore({
						patentes: patentesProcessed,
					});
				} catch (error) {
					console.error('Error en getPatentes:', error);
					setStore({
						error: "patentes " + error.message,
						patentes: [] // Establecer un valor por defecto
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			getPatente: async (id) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/patentes/" + id, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					const data = await response.json();
					// Convertir los datos antes de almacenarlos
					const patenteProcessed = {
						...data,
						codigo: data.codigo ? JSON.parse(data.codigo.replace(/'/g, '"')) : [],
						fechaEdicion: data.fechaEdicion ? JSON.parse(data.fechaEdicion.replace(/'/g, '"')) : [],
						numeroExpediente: data.numeroExpediente ? JSON.parse(data.numeroExpediente.replace(/'/g, '"')) : []
					};

					setStore({
						patente: patenteProcessed,
					});
				} catch (error) {
					console.error("Error en getPatente:", error);
					setStore({
						error: "patente " + error.message,
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			crearPatente: async (datosPatente) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/patentes", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify(datosPatente),
					});

					const data = await response.json();
					setStore({
						response: data,
					});
				} catch (error) {
					console.error("Error en crearPatente:", error);
					setStore({
						error: error.message,
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			editarPatente: async (id, datosPatente, onVista, busqueda=null, numeroRol=null) => {
				const store = getStore();
				const actions = getActions();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					// Primero hacemos el PUT a la BD principal
					const response = await fetch("https://denegocios.herokuapp.com/patentes/" + id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify(datosPatente),
					});
					
					const data = await response.json();
					setStore({ response: data });
			
					// Si es Providencia, enviar POST a Zapier de Providencia con número de rol
					if (datosPatente.comunaPatente === "Providencia" && numeroRol && datosPatente.estado === "Terminada") {
						await fetch("https://hooks.zapier.com/hooks/catch/2499772/uzy6ijx/", {
							method: "POST",
							body: JSON.stringify({
								rut: datosPatente.rut,
								razonSocial: datosPatente.razonSocial,
								correo: datosPatente.correo,
								numeroRol: numeroRol
							}),
						});
					}
					// Si es Santiago y el estado es "Terminada", mantener lógica actual
					else if (datosPatente.comunaPatente === "Santiago" && datosPatente.estado === "Terminada") {
						await fetch("https://hooks.zapier.com/hooks/catch/2499772/2s6pjc9/", {
							method: "POST",
							body: JSON.stringify({
								rut: datosPatente.rut,
								razonSocial: datosPatente.razonSocial,
								correo: datosPatente.correo,
							}),
						});
					}
			
					// Actualizamos la vista según corresponda
					if (onVista === "Todas" || onVista ==="EnTramite" || onVista === "Muertas" || onVista === "Terminadas") {
						actions.getPatente(id);
						actions.getPatentes(onVista);
					} else if (onVista === "Busqueda") {
						actions.getPatente(id);
						actions.getBusquedaIndividualPatente(busqueda);
					} else if (onVista === "PorMes") {
						actions.getPatente(id);
						const filtro = (busqueda && busqueda.year && busqueda.month)
							? busqueda
							: getStore().patentesFiltroMes;
						if (filtro) {
							actions.getPatentesPorFechaCreacion(filtro.year, filtro.month);
						}
					} else if (onVista === "RevisionVencida") {
						actions.getPatente(id);
						actions.getPatentesRevisionVencida();
					}
				} catch (error) {
					console.error("Error en editarPatente:", error);
					setStore({ error: error.message });
				} finally {
					setStore({ spinner: false });
				}
			},

			
			borrarPatente: async (id) => {
				const store = getStore();
				const actions = getActions();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/patentes/" + id, {
						method: "DELETE",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					const data = await response.json();
					setStore({
						response: data,
					});
					
					actions.getPatentes();
				} catch (error) {
					console.error("Error en borrarPatente:", error);
					setStore({
						error: error.message,
					});
				} finally {
					setStore({ spinner: false });
				}
			},

			getPatentesPorFechaCreacion: async (year, month) => {
				setStore({ spinner: true, patentesFiltroMes: { year, month } });

				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}

					const idToken = await currentUser.getIdToken(true);

					const response = await fetch("https://denegocios.herokuapp.com/patentesPorFechaCreacion", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({ year, month }),
					});

					if (!response.ok) {
						throw new Error("Error al buscar patentes por mes");
					}

					const data = await response.json();
					const procesarJSON = (str) => {
						if (!str) return [];
						try {
							return JSON.parse(str.replace(/'/g, '"'));
						} catch (e) {
							console.warn("Error procesando JSON:", e);
							return [];
						}
					};

					const patentesProcessed = Array.isArray(data)
						? data.map(patente => ({
							...patente,
							codigo: procesarJSON(patente.codigo),
							fechaEdicion: procesarJSON(patente.fechaEdicion),
							numeroExpediente: procesarJSON(patente.numeroExpediente)
						}))
						: [];

					setStore({
						patentes: patentesProcessed,
						error: null
					});
					return true;
				} catch (error) {
					console.error("Error en getPatentesPorFechaCreacion:", error);
					setStore({
						error: "Error al buscar patentes por mes: " + error.message,
						patentes: []
					});
					return false;
				} finally {
					setStore({ spinner: false });
				}
			},

			getPatentesRevisionVencida: async () => {
				setStore({ spinner: true });

				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}

					const idToken = await currentUser.getIdToken(true);

					const response = await fetch("https://denegocios.herokuapp.com/patentesRevisionVencida", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
					});

					if (!response.ok) {
						throw new Error("Error al buscar patentes con revisión vencida");
					}

					const data = await response.json();
					const procesarJSON = (str) => {
						if (!str) return [];
						try {
							return JSON.parse(str.replace(/'/g, '"'));
						} catch (e) {
							console.warn("Error procesando JSON:", e);
							return [];
						}
					};

					const patentesProcessed = Array.isArray(data)
						? data.map(patente => ({
							...patente,
							codigo: procesarJSON(patente.codigo),
							fechaEdicion: procesarJSON(patente.fechaEdicion),
							numeroExpediente: procesarJSON(patente.numeroExpediente)
						}))
						: [];

					setStore({
						patentes: patentesProcessed,
						error: null
					});
					return true;
				} catch (error) {
					console.error("Error en getPatentesRevisionVencida:", error);
					setStore({
						error: "Error al buscar patentes con revisión vencida: " + error.message,
						patentes: []
					});
					return false;
				} finally {
					setStore({ spinner: false });
				}
			},

			getBusquedaIndividualPatente: async (busqueda) => {
				const store = getStore();
				setStore({ spinner: true });
				
				try {
					const currentUser = auth.currentUser;
					if (!currentUser) {
						throw new Error("No hay usuario autenticado");
					}
					
					const idToken = await currentUser.getIdToken(true);
					
					const response = await fetch("https://denegocios.herokuapp.com/busquedaPatentes", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Authorization": `Bearer ${idToken}`
						},
						body: JSON.stringify({
							busqueda: busqueda
						}),
					});

					if (!response.ok) {
						if (response.status === 404) {
							setStore({
								patentesEncontradas: [],
								error: "No se encontraron resultados para la búsqueda"
							});
							return false;
						}
						throw new Error("Error en la búsqueda");
					}

					const data = await response.json();
					// Convertir los datos antes de almacenarlos
					const patentesProcessed = data.map(patente => ({
						...patente,
						codigo: patente.codigo ? JSON.parse(patente.codigo.replace(/'/g, '"')) : [],
						fechaEdicion: patente.fechaEdicion ? JSON.parse(patente.fechaEdicion.replace(/'/g, '"')) : [],
						numeroExpediente: patente.numeroExpediente ? JSON.parse(patente.numeroExpediente.replace(/'/g, '"')) : []
					}));

					setStore({
						patentesEncontradas: patentesProcessed,
						error: null
					});
					return true;

				} catch (error) {
					setStore({
						error: "Error en la búsqueda: " + error.message,
						patentesEncontradas: []
					});
					return false;
				} finally {
					setStore({ spinner: false });
				}
			},
		},
	};
};

export default getState;
